"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Gebuehren model module.
 * @module model/Gebuehren
 * @version 1.0.44
 */
var Gebuehren = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Gebuehren</code>.
   * Gebühren einer Filiale 
   * @alias module:model/Gebuehren
   * @param gpNummer {String} GP-Nummer der Filiale
   * @param bankleitzahl {String} Bankleitzahl der Filiale
   * @param soDvBetrag {Number} Gesamt Betrag der Lieferung von Sorten
   * @param emDvBetragGes {Number} Gesamt Betrag bei Lieferung von Edelmetallen
   * @param emDvBetrag {Number} Betrag der Lieferung von Edelmetallen
   * @param soProvisionRate {String} Provisionsrate bei Sorten
   * @param emDvMaxBetrag {Number} Maximaler Betrag bei Lieferung von Edelmetallen
   * @param soDvMaxBetrag {Number} Maximaler Betrag bei Lieferung von Sorten
   * @param emFvMaxBetrag {Number} Maximaler Betrag bei Abholung von Edelmetallen
   * @param soFvMaxBetrag {Number} Maximaler Betrag bei Abholung von Sorten
   * @param emFvBetragGes {Number} Gesamt Betrag bei Abholung von Edelmetallen
   * @param soFvBetragGes {Number} Gesamt Betrag bei Abholung von Sorten
   */
  function Gebuehren(gpNummer, bankleitzahl, soDvBetrag, emDvBetragGes, emDvBetrag, soProvisionRate, emDvMaxBetrag, soDvMaxBetrag, emFvMaxBetrag, soFvMaxBetrag, emFvBetragGes, soFvBetragGes) {
    _classCallCheck(this, Gebuehren);
    Gebuehren.initialize(this, gpNummer, bankleitzahl, soDvBetrag, emDvBetragGes, emDvBetrag, soProvisionRate, emDvMaxBetrag, soDvMaxBetrag, emFvMaxBetrag, soFvMaxBetrag, emFvBetragGes, soFvBetragGes);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Gebuehren, null, [{
    key: "initialize",
    value: function initialize(obj, gpNummer, bankleitzahl, soDvBetrag, emDvBetragGes, emDvBetrag, soProvisionRate, emDvMaxBetrag, soDvMaxBetrag, emFvMaxBetrag, soFvMaxBetrag, emFvBetragGes, soFvBetragGes) {
      obj['gpNummer'] = gpNummer;
      obj['bankleitzahl'] = bankleitzahl;
      obj['soDvBetrag'] = soDvBetrag;
      obj['emDvBetragGes'] = emDvBetragGes;
      obj['emDvBetrag'] = emDvBetrag;
      obj['soProvisionRate'] = soProvisionRate;
      obj['emDvMaxBetrag'] = emDvMaxBetrag;
      obj['soDvMaxBetrag'] = soDvMaxBetrag;
      obj['emFvMaxBetrag'] = emFvMaxBetrag;
      obj['soFvMaxBetrag'] = soFvMaxBetrag;
      obj['emFvBetragGes'] = emFvBetragGes;
      obj['soFvBetragGes'] = soFvBetragGes;
    }

    /**
     * Constructs a <code>Gebuehren</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Gebuehren} obj Optional instance to populate.
     * @return {module:model/Gebuehren} The populated <code>Gebuehren</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Gebuehren();
        if (data.hasOwnProperty('gpNummer')) {
          obj['gpNummer'] = _ApiClient.default.convertToType(data['gpNummer'], 'String');
        }
        if (data.hasOwnProperty('bankleitzahl')) {
          obj['bankleitzahl'] = _ApiClient.default.convertToType(data['bankleitzahl'], 'String');
        }
        if (data.hasOwnProperty('soBetrag')) {
          obj['soBetrag'] = _ApiClient.default.convertToType(data['soBetrag'], 'Number');
        }
        if (data.hasOwnProperty('soProz')) {
          obj['soProz'] = _ApiClient.default.convertToType(data['soProz'], 'Number');
        }
        if (data.hasOwnProperty('soDvBetrag')) {
          obj['soDvBetrag'] = _ApiClient.default.convertToType(data['soDvBetrag'], 'Number');
        }
        if (data.hasOwnProperty('emBetrag')) {
          obj['emBetrag'] = _ApiClient.default.convertToType(data['emBetrag'], 'Number');
        }
        if (data.hasOwnProperty('emProz')) {
          obj['emProz'] = _ApiClient.default.convertToType(data['emProz'], 'Number');
        }
        if (data.hasOwnProperty('emDvBetragGes')) {
          obj['emDvBetragGes'] = _ApiClient.default.convertToType(data['emDvBetragGes'], 'Number');
        }
        if (data.hasOwnProperty('emDvBetrag')) {
          obj['emDvBetrag'] = _ApiClient.default.convertToType(data['emDvBetrag'], 'Number');
        }
        if (data.hasOwnProperty('emVK')) {
          obj['emVK'] = _ApiClient.default.convertToType(data['emVK'], 'String');
        }
        if (data.hasOwnProperty('emAK')) {
          obj['emAK'] = _ApiClient.default.convertToType(data['emAK'], 'String');
        }
        if (data.hasOwnProperty('soVK')) {
          obj['soVK'] = _ApiClient.default.convertToType(data['soVK'], 'String');
        }
        if (data.hasOwnProperty('soAK')) {
          obj['soAK'] = _ApiClient.default.convertToType(data['soAK'], 'String');
        }
        if (data.hasOwnProperty('konditionKz')) {
          obj['konditionKz'] = _ApiClient.default.convertToType(data['konditionKz'], 'String');
        }
        if (data.hasOwnProperty('soProvisionRate')) {
          obj['soProvisionRate'] = _ApiClient.default.convertToType(data['soProvisionRate'], 'String');
        }
        if (data.hasOwnProperty('emProvisionZusatzKz')) {
          obj['emProvisionZusatzKz'] = _ApiClient.default.convertToType(data['emProvisionZusatzKz'], 'String');
        }
        if (data.hasOwnProperty('emDvMaxBetrag')) {
          obj['emDvMaxBetrag'] = _ApiClient.default.convertToType(data['emDvMaxBetrag'], 'Number');
        }
        if (data.hasOwnProperty('soDvMaxBetrag')) {
          obj['soDvMaxBetrag'] = _ApiClient.default.convertToType(data['soDvMaxBetrag'], 'Number');
        }
        if (data.hasOwnProperty('emFvMaxBetrag')) {
          obj['emFvMaxBetrag'] = _ApiClient.default.convertToType(data['emFvMaxBetrag'], 'Number');
        }
        if (data.hasOwnProperty('soFvMaxBetrag')) {
          obj['soFvMaxBetrag'] = _ApiClient.default.convertToType(data['soFvMaxBetrag'], 'Number');
        }
        if (data.hasOwnProperty('emFvBetragGes')) {
          obj['emFvBetragGes'] = _ApiClient.default.convertToType(data['emFvBetragGes'], 'Number');
        }
        if (data.hasOwnProperty('soFvBetragGes')) {
          obj['soFvBetragGes'] = _ApiClient.default.convertToType(data['soFvBetragGes'], 'Number');
        }
        if (data.hasOwnProperty('soKz')) {
          obj['soKz'] = _ApiClient.default.convertToType(data['soKz'], 'String');
        }
        if (data.hasOwnProperty('emKz')) {
          obj['emKz'] = _ApiClient.default.convertToType(data['emKz'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Gebuehren</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Gebuehren</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(Gebuehren.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['gpNummer'] && !(typeof data['gpNummer'] === 'string' || data['gpNummer'] instanceof String)) {
        throw new Error("Expected the field `gpNummer` to be a primitive type in the JSON string but got " + data['gpNummer']);
      }
      // ensure the json data is a string
      if (data['bankleitzahl'] && !(typeof data['bankleitzahl'] === 'string' || data['bankleitzahl'] instanceof String)) {
        throw new Error("Expected the field `bankleitzahl` to be a primitive type in the JSON string but got " + data['bankleitzahl']);
      }
      // ensure the json data is a string
      if (data['emVK'] && !(typeof data['emVK'] === 'string' || data['emVK'] instanceof String)) {
        throw new Error("Expected the field `emVK` to be a primitive type in the JSON string but got " + data['emVK']);
      }
      // ensure the json data is a string
      if (data['emAK'] && !(typeof data['emAK'] === 'string' || data['emAK'] instanceof String)) {
        throw new Error("Expected the field `emAK` to be a primitive type in the JSON string but got " + data['emAK']);
      }
      // ensure the json data is a string
      if (data['soVK'] && !(typeof data['soVK'] === 'string' || data['soVK'] instanceof String)) {
        throw new Error("Expected the field `soVK` to be a primitive type in the JSON string but got " + data['soVK']);
      }
      // ensure the json data is a string
      if (data['soAK'] && !(typeof data['soAK'] === 'string' || data['soAK'] instanceof String)) {
        throw new Error("Expected the field `soAK` to be a primitive type in the JSON string but got " + data['soAK']);
      }
      // ensure the json data is a string
      if (data['konditionKz'] && !(typeof data['konditionKz'] === 'string' || data['konditionKz'] instanceof String)) {
        throw new Error("Expected the field `konditionKz` to be a primitive type in the JSON string but got " + data['konditionKz']);
      }
      // ensure the json data is a string
      if (data['soProvisionRate'] && !(typeof data['soProvisionRate'] === 'string' || data['soProvisionRate'] instanceof String)) {
        throw new Error("Expected the field `soProvisionRate` to be a primitive type in the JSON string but got " + data['soProvisionRate']);
      }
      // ensure the json data is a string
      if (data['emProvisionZusatzKz'] && !(typeof data['emProvisionZusatzKz'] === 'string' || data['emProvisionZusatzKz'] instanceof String)) {
        throw new Error("Expected the field `emProvisionZusatzKz` to be a primitive type in the JSON string but got " + data['emProvisionZusatzKz']);
      }
      // ensure the json data is a string
      if (data['soKz'] && !(typeof data['soKz'] === 'string' || data['soKz'] instanceof String)) {
        throw new Error("Expected the field `soKz` to be a primitive type in the JSON string but got " + data['soKz']);
      }
      // ensure the json data is a string
      if (data['emKz'] && !(typeof data['emKz'] === 'string' || data['emKz'] instanceof String)) {
        throw new Error("Expected the field `emKz` to be a primitive type in the JSON string but got " + data['emKz']);
      }
      return true;
    }
  }]);
}();
Gebuehren.RequiredProperties = ["gpNummer", "bankleitzahl", "soDvBetrag", "emDvBetragGes", "emDvBetrag", "soProvisionRate", "emDvMaxBetrag", "soDvMaxBetrag", "emFvMaxBetrag", "soFvMaxBetrag", "emFvBetragGes", "soFvBetragGes"];

/**
 * GP-Nummer der Filiale
 * @member {String} gpNummer
 */
Gebuehren.prototype['gpNummer'] = undefined;

/**
 * Bankleitzahl der Filiale
 * @member {String} bankleitzahl
 */
Gebuehren.prototype['bankleitzahl'] = undefined;

/**
 * @member {Number} soBetrag
 */
Gebuehren.prototype['soBetrag'] = undefined;

/**
 * @member {Number} soProz
 */
Gebuehren.prototype['soProz'] = undefined;

/**
 * Gesamt Betrag der Lieferung von Sorten
 * @member {Number} soDvBetrag
 */
Gebuehren.prototype['soDvBetrag'] = undefined;

/**
 * @member {Number} emBetrag
 */
Gebuehren.prototype['emBetrag'] = undefined;

/**
 * @member {Number} emProz
 */
Gebuehren.prototype['emProz'] = undefined;

/**
 * Gesamt Betrag bei Lieferung von Edelmetallen
 * @member {Number} emDvBetragGes
 */
Gebuehren.prototype['emDvBetragGes'] = undefined;

/**
 * Betrag der Lieferung von Edelmetallen
 * @member {Number} emDvBetrag
 */
Gebuehren.prototype['emDvBetrag'] = undefined;

/**
 * @member {String} emVK
 */
Gebuehren.prototype['emVK'] = undefined;

/**
 * @member {String} emAK
 */
Gebuehren.prototype['emAK'] = undefined;

/**
 * @member {String} soVK
 */
Gebuehren.prototype['soVK'] = undefined;

/**
 * @member {String} soAK
 */
Gebuehren.prototype['soAK'] = undefined;

/**
 * @member {String} konditionKz
 */
Gebuehren.prototype['konditionKz'] = undefined;

/**
 * Provisionsrate bei Sorten
 * @member {String} soProvisionRate
 */
Gebuehren.prototype['soProvisionRate'] = undefined;

/**
 * @member {String} emProvisionZusatzKz
 */
Gebuehren.prototype['emProvisionZusatzKz'] = undefined;

/**
 * Maximaler Betrag bei Lieferung von Edelmetallen
 * @member {Number} emDvMaxBetrag
 */
Gebuehren.prototype['emDvMaxBetrag'] = undefined;

/**
 * Maximaler Betrag bei Lieferung von Sorten
 * @member {Number} soDvMaxBetrag
 */
Gebuehren.prototype['soDvMaxBetrag'] = undefined;

/**
 * Maximaler Betrag bei Abholung von Edelmetallen
 * @member {Number} emFvMaxBetrag
 */
Gebuehren.prototype['emFvMaxBetrag'] = undefined;

/**
 * Maximaler Betrag bei Abholung von Sorten
 * @member {Number} soFvMaxBetrag
 */
Gebuehren.prototype['soFvMaxBetrag'] = undefined;

/**
 * Gesamt Betrag bei Abholung von Edelmetallen
 * @member {Number} emFvBetragGes
 */
Gebuehren.prototype['emFvBetragGes'] = undefined;

/**
 * Gesamt Betrag bei Abholung von Sorten
 * @member {Number} soFvBetragGes
 */
Gebuehren.prototype['soFvBetragGes'] = undefined;

/**
 * @member {String} soKz
 */
Gebuehren.prototype['soKz'] = undefined;

/**
 * @member {String} emKz
 */
Gebuehren.prototype['emKz'] = undefined;
var _default = exports.default = Gebuehren;